import { Attrs, MinzeElement } from 'minze'

export interface LvcCulturalProfileIcon {}

export class LvcCulturalProfileIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 406],
    ['height', 315],
  ]
  html = () => `
    <img width="${this.width}" height="${this.height}" src="https://cloud.squidex.io/api/assets/lvc-dev/86311818-057e-416d-9d5d-10780607e3ce/ecoute.png?version=0&auto=true" loading="eager"/>
    `

  css = () => `
  `
}
